module.exports = __webpack_public_path__ + "static/CLASSROOM0-6f45989350e911e65316923932af1b85.jpg";